import { render, staticRenderFns } from "./Conversations.vue?vue&type=template&id=bf3b221a"
import script from "./Conversations.vue?vue&type=script&lang=js"
export * from "./Conversations.vue?vue&type=script&lang=js"
import style0 from "./Conversations.vue?vue&type=style&index=0&id=bf3b221a&prod&lang=css"
import style1 from "./Conversations.vue?vue&type=style&index=1&id=bf3b221a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports